import UserArea from "./UserArea";

export default UserArea;